module.exports = __webpack_public_path__ + "img/31.202f1f80.jpg";